import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { timer } from 'rxjs';
import { delay, tap } from 'rxjs/operators';

export type ButtonState = 'loading' | 'success' | 'error' | 'initial';

@Component({
  selector: 'cross-check-btn',
  templateUrl: './cross-check-btn.component.html',
  styleUrls: ['./cross-check-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
  ]
})
export class CrossCheckBtnComponent {
  // Use this instead of click due to the last one emits when button is disabled
  @Output() onPress = new EventEmitter<void>();

  @Output() onAfterAnimation = new EventEmitter<ButtonState>();

  @Input() set state(state: ButtonState) {
    this._state = state;

    if (state === 'success' || state === 'error') {
      timer(state === 'success' ? this.successDelay : this.failDelay)
        .pipe(
          tap(() => this.onAfterAnimation.emit(state)),
          delay(this.restoreDelay),
        )
        .subscribe(() => {
          this.state = 'initial';
          this._cdRef.detectChanges();
        });
    }
  }

  get state(): ButtonState {
    return this._state;
  }

  @Input() isDisabled: boolean = false;
  @Input() buttonType: 'submit' | 'button' = 'submit';
  @Input() buttonText: string = '';
  @Input() successDelay = 1500;
  @Input() failDelay = 1000;
  @Input() restoreDelay = 3000;

  @Input() dataAttrs: Record<string, string> = {};

  private _state!: ButtonState;

  constructor(private _cdRef: ChangeDetectorRef) {}
}
